/* iSpice e-gift card page header - 2026-10-07
   Amount chips in the header select the same amount in the theme's product form below
   (its "Denominations" radios, name="option-0"), then scroll to it and give it a short glow.
   The chips also follow the form, so whichever is picked shows as pressed in both places.
   Without this script the chips are plain buttons and "Choose an amount" still jumps to the form. */
(function () {
  'use strict';
  function init(root) {
    var form = document.querySelector('form.shopify-product-form[action*="/cart/add"]');
    var box = form ? (form.closest('.product__information, .product-block-container, .product_section, section, .shopify-section') || form) : null;
    if (box && !document.getElementById('isx-gc-buy')) box.id = 'isx-gc-buy';

    // page-wide faint gift pattern uses the same file as the header
    var pat = getComputedStyle(root).getPropertyValue('--isx-gc-pattern');
    if (pat) document.body.style.setProperty('--isx-gc-pattern-page', pat);

    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-isx-gc-amt]'));
    function radios() { return form ? Array.prototype.slice.call(form.querySelectorAll('input[type=radio][name^="option-"]')) : []; }
    function mark() {
      var on = radios().filter(function (r) { return r.checked; })[0];
      chips.forEach(function (c) { c.classList.toggle('is-on', !!on && c.getAttribute('data-isx-gc-amt') === on.value); c.setAttribute('aria-pressed', String(!!on && c.getAttribute('data-isx-gc-amt') === on.value)); });
    }
    function goToForm() {
      if (!box) return;
      box.scrollIntoView({ behavior: 'smooth', block: 'start' });
      box.classList.remove('isx-gc-flash'); void box.offsetWidth; box.classList.add('isx-gc-flash');
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        var value = c.getAttribute('data-isx-gc-amt');
        var r = radios().filter(function (x) { return x.value === value; })[0];
        if (r) {
          var label = r.id ? form.querySelector('label[for="' + r.id + '"]') : null;
          (label || r).click();            // the theme updates price, variant id and button itself
          if (!r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
        } else if (form) {                 // no radios: fall back to the variant select
          var sel = form.querySelector('select[name="id"]');
          if (sel) { sel.value = c.getAttribute('data-variant'); sel.dispatchEvent(new Event('change', { bubbles: true })); }
        }
        mark();
        goToForm();
      });
    });
    // the theme's own amount pills: add the pay price under each, and a pay line above Add to cart.
    // Every price is worked out from the amount itself ("$150.00" x (100 - saving) %), never looked up,
    // so a re-drawn page (theme editor, variant change) can never show another card's price.
    var savePct = +root.getAttribute('data-save') || 0;
    var moneyFmt = root.getAttribute('data-money') || '${{amount}}';
    var payLabel = root.getAttribute('data-pay-label') || 'you pay';
    var noteTpl = root.getAttribute('data-paynote') || '';
    function cents(value) { var n = parseFloat(String(value).replace(/[^0-9.]/g, '')); return isNaN(n) ? null : Math.round(n * 100); }
    function money(c) {
      var v = (c / 100).toFixed(2);
      return moneyFmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(c / 100)).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','))
        .replace(/\{\{\s*amount\s*\}\}/, v.replace(/\B(?=(\d{3})+(?!\d))/g, ',')).replace(/<[^>]+>/g, '');
    }
    function payFor(value) { var c = cents(value); return c === null ? '' : money(Math.round(c * (100 - savePct) / 100)); }
    function short(value) { return String(value).replace(/\.00$/, ''); }
    function esc(t) { return String(t).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }
    function tiles() {
      if (!savePct) return;
      radios().forEach(function (r) {
        var lab = r.id ? form.querySelector('label[for="' + r.id + '"]') : null;
        if (!lab) return;
        var first = lab.firstChild; if (first && first.nodeType === 3) first.nodeValue = short(r.value);
        var sm = lab.querySelector('.isx-gc-sw-pay');
        if (!sm) { sm = document.createElement('small'); sm.className = 'isx-gc-sw-pay'; lab.appendChild(sm); }
        sm.textContent = payLabel + ' ' + payFor(r.value);
      });
    }
    function payLine() {
      if (!form || !savePct || !noteTpl) return;
      var note = form.querySelector('.isx-gc-paynote'), fs = form.querySelector('fieldset.swatch');
      if (!note && fs) { note = document.createElement('p'); note.className = 'isx-gc-paynote'; note.setAttribute('aria-live', 'polite'); fs.parentNode.insertBefore(note, fs.nextSibling); }
      if (!note) return;
      var on = radios().filter(function (r) { return r.checked; })[0];
      if (!on || cents(on.value) === null) { note.hidden = true; return; }
      note.hidden = false;
      note.innerHTML = '<span>' + esc(noteTpl).replace('[amount]', esc(short(on.value))).replace('[pay]', '<b>' + esc(payFor(on.value)) + '</b>') + '</span><em>Save ' + savePct + '%</em>';
    }
    var _mark = mark; mark = function () { tiles(); _mark(); payLine(); };
    var buy = root.querySelector('[data-isx-gc-buy]');
    if (buy) buy.addEventListener('click', function (e) { if (box) { e.preventDefault(); goToForm(); } });
    if (form) form.addEventListener('change', mark);
    mark();
  }
  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-isx-gc]'), function (root) {
      if (root.dataset.isxDone) return;
      root.dataset.isxDone = '1';
      try { init(root); } catch (e) { console.warn('ispice-giftcard', e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);   // theme editor: a changed setting re-draws the section
})();
